import React from 'react';

// Elevate logo mark — a minimal serif "E" whose middle bar extends
// beyond the top and bottom bars, ending in a gold apex.
// The extended stroke signals reach, elevation and forward movement.
const Logo = ({ size = 44, dark = false, mono = false, className = '' }) => {
  const ink = mono ? 'currentColor' : dark ? '#F7F3EC' : '#1F3A2E';
  const cream = mono ? '#0000' : dark ? '#1F3A2E' : '#F7F3EC';
  const gold = mono ? 'currentColor' : '#B8935A';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Elevate Medical Clinics logo"
      role="img"
    >
      {/* Rounded shield */}
      <rect x="4" y="4" width="56" height="56" rx="14" ry="14" fill={ink} />

      {/* Vertical spine */}
      <rect x="18" y="16" width="3.4" height="32" rx="0.6" fill={cream} />

      {/* Top bar — short */}
      <rect x="18" y="16" width="18" height="3.4" rx="0.6" fill={cream} />

      {/* Bottom bar — short */}
      <rect x="18" y="44.6" width="18" height="3.4" rx="0.6" fill={cream} />

      {/* Middle bar — extends BEYOND the top/bottom in gold */}
      <rect x="18" y="30.4" width="30" height="3.2" rx="0.6" fill={gold} />

      {/* Apex tick — subtle upward flourish at the extended end */}
      <path
        d="M48 32 L53 27"
        stroke={gold}
        strokeWidth="3.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Wordmark = ({ dark = false, small = false }) => (
  <div className="leading-tight whitespace-nowrap">
    <div
      className={`font-serif tracking-tight whitespace-nowrap ${small ? 'text-[18px]' : 'text-[20px]'}`}
      style={{ color: dark ? '#F7F3EC' : '#1F3A2E', letterSpacing: '-0.015em' }}
    >
      Elevate
    </div>
    <div
      className="uppercase whitespace-nowrap"
      style={{
        color: dark ? 'rgba(247,243,236,0.7)' : '#6E7772',
        fontSize: 9,
        letterSpacing: '0.3em',
        marginTop: 2,
      }}
    >
      Medical Clinics
    </div>
  </div>
);

export default Logo;
